<div class="container-fluid top-nav pt-2 app">
  <div class="row">
    <div class="col pl-0 pr-0">
      <div class="card pl-2 pr-2 mt-2 border-0">
        <div class="row ml-0 mr-0 mb-2 p-2 rounded border-0 bg-secondary">
          <div class="col-xl-2 col-lg-2 col-md-2 col">
            <h3 matTooltip="{{project?.title}}" matTooltipPosition="below" matTooltipShowDelay="500"
              class="h3 mb-0 pl-1 align-middle text-truncate lh-33">{{project?.title}}</h3>
            <!-- <div class="collapse portaloptionsCollapse fade" id="portaloptionsCollapse5">
                <p class="mb-1 pt-2 pl-1 w-100" style="width:250%!important; overflow: show;">{{project?.projectdescription}}</p>
              </div> -->
          </div>
          <div class="col-xl-2 col-lg-2 col-md-2 d-none d-lg-block lh-35 align-middle">
            <app-customername *ngIf="project" [customerId]="project.customer"></app-customername>
          </div>
          <div class="col d-none d-md-block">
            <div [@inbgOutAnimation] *ngIf="!filtertoggle" class="row">
              <div class="col">
                <app-projectprogress *ngIf="project" [projectId]="project.projectId" [fat]="true"></app-projectprogress>
              </div>
            </div>
            <!-- <div class="collapse portaloptionsCollapse fade ml-4" id="portaloptionsCollapse6">
              <p class="mb-1 pt-2 pl-4 ml-4 w-50 text-right ">Start date - {{project?.start_date}}</p>
              <p class="mb-1 pt-2 pl-4 ml-4 w-50 text-right">End date - {{project?.end_date}}</p>
            </div> -->
            <!-- <div [@inbgOutAnimation] *ngIf="filtertoggle" class="row d-none d-md-block"> 
              <div class="col">
                <div class="row">
                  <div class="col-auto pl-4 pr-0">
                    <p class="p mb-0 lh-33 align-middle pl-1 pt-0 w-100">{{ 'projectportal.filterby' | trans }}</p>
                  </div>
                  <div class="col-auto mx-auto pl-0">
                    <button (click)="filterTaskList('myTasks')" class="btn" style="float: right;" [ngClass]="{'bg-primary': taskListFilter == 'myTasks'}">
                      <p class="btn-text" [ngClass]="{'text-light': taskListFilter == 'myTasks'}">{{ 'projectportal.mytasks' | trans }}</p></button>
                  </div>
                  <div class="col-auto mx-auto">
                    <button (click)="filterTaskList('customerTasks')" class="btn" [ngClass]="{'bg-primary': taskListFilter == 'customerTasks'}">
                      <p class="btn-text" [ngClass]="{'text-light': taskListFilter == 'customerTasks'}">{{ 'projectportal.customer' | trans }}</p></button>
                  </div>
                  <div class="col-auto mx-auto">
                    <button (click)="filterTaskList('vendorTasks')" class="btn" [ngClass]="{'bg-primary': taskListFilter == 'vendorTasks'}">
                      <p class="btn-text" [ngClass]="{'text-light': taskListFilter == 'vendorTasks'}">{{ 'projectportal.vendor' | trans }}</p></button>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div *ngIf="canCreateStage()" class="col-auto float-right">
            <span *ngIf="canCreateStage()" (click)="setNewStage()" type="button" data-toggle="modal"
              class="material-icons m-0 p-0 rounded-circle text-dark center p-1 d-block d-md-none"
              data-target="#stagemodal" style="background-color: var(--button-bg-color);">
              add
            </span>
            <button *ngIf="canCreateStage()" id="createstage" (click)="setNewStage()" type="button" data-toggle="modal"
              class="btn d-none d-md-block" data-target="#stagemodal">
              <h6 class="btn-text lh-20 pl-3 pr-3">{{ 'projectportal.addstage' | trans }}</h6>
            </button>
          </div>

          <!---- Change view direction toggle starts here -
          <div class="col-auto collapse fade portaloptionsCollapse" id="portaloptionsCollapse2"> 
            <span class="material-icons m-0 rounded-circle btn portal-icon p-1 w-33 h-33" matTooltip="Toggles list view" matTooltipPosition="above" matTooltipShowDelay="500">
              rotate_90_degrees_ccw
            </span>
          </div>
          change view direction ends here ---->
          <div class="collapse portaloptionsCollapse" id="portaloptionsCollapse3">
            <div class="col-auto d-none d-lg-block pl-0 float-right">
              <!-- <span *ngIf="!filtertoggle" (click)="filterToggle()" class="material-icons m-0 ml-3 rounded-circle btn portal-icon p-1 w-33 h-33" matTooltip="{{ 'projectportal.enablefilters' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
                  filter_alt
                </span>
                <span *ngIf="filtertoggle" (click)="filterToggle()" class="material-icons m-0 ml-3 rounded-circle btn portal-icon p-1 w-33 h-33" matTooltip="{{ 'projectportal.disablefilters' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
                  highlight_off
                </span> -->
              <app-projectimeshift *ngIf="canCreateStage()"></app-projectimeshift>
            </div>
          </div>
          <div class="collapse portaloptionsCollapse" id="portaloptionsCollapse3">
            <!--div class="col-auto d-none d-lg-block pl-0 float-right">
              <span *ngIf="!filtertoggle" (click)="filterToggle()" class="material-icons m-0 rounded-circle btn portal-icon p-1 w-33 h-33" matTooltip="Enables filters to sort tasks" matTooltipPosition="above" matTooltipShowDelay="500">
                  filter_alt
                </span>
                <span *ngIf="filtertoggle" (click)="filterToggle()" class="material-icons m-0 rounded-circle btn portal-icon p-1 w-33 h-33" matTooltip="Disables filters" matTooltipPosition="above" matTooltipShowDelay="500">
                  highlight_off
                </span>
            </div-->
            <app-tagaddremove *ngIf="canCreateStage() && project" [entityId]="project.projectId" [smalltype]="true"
              [tagtype]="'project'"></app-tagaddremove>
          </div>

          <!-- <div class="float-right collapse portaloptionsCollapse fade" id="portaloptionsCollapse4" matTooltip="Notification settings" matTooltipPosition="above" matTooltipShowDelay="500">
            <button matTooltip="Show customer view" matTooltipPosition="above" matTooltipShowDelay="500" aria-expanded="false" class="btn-empty border-0">
              <span class="material-icons m-0 rounded-circle portal-icon p-1 w-33 h-33">
                preview
              </span>
            </button>      
          </div>    -->


          <!----BULK ASSIGN ICON
      <div class="float-right collapse portaloptionsCollapse fade mr-3 " matTooltip="{{ 'projectportal.bulkselecttip' | trans }}"  matTooltipPosition="above" matTooltipShowDelay="500">
        <span class="material-icons m-0 rounded-circle btn portal-icon p-1 w-33 h-33">
          library_add_check
          </span>  </div>   
    BULK ASSIGN ICON END--->

          <div class="float-right collapse portaloptionsCollapse fade" id="portaloptionsCollapse2"
            matTooltip="{{ 'projectportal.notificationsettings' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500">
            <span id="settingsmodaltoggler" data-toggle="modal" data-target="#settingsModal"
              class="material-icons m-0 rounded-circle btn portal-icon p-1 w-33 h-33">
              settings
            </span>
          </div>
          <!-- <div class="float-right collapse portaloptionsCollapse fade" id="portaloptionsCollapse2" matTooltip="Notification settings" matTooltipPosition="above" matTooltipShowDelay="500">
              <app-projectnotification [projectId]="project.projectId"></app-projectnotification>
            </div>    -->

          <div class="float-right" matTooltip="{{ 'projectportal.viewoptions' | trans }}" viewoptions
            matTooltipPosition="above" matTooltipShowDelay="500">
            <button id="optionstoggler" data-toggle="collapse" href=".portaloptionsCollapse" aria-expanded="false"
              aria-controls="portaloptionsCollapse1 portaloptionsCollapse2 portaloptionsCollapse3 portaloptionsCollapse4 portaloptionsCollapse5 portaloptionsCollapse6"
              class="btn-empty border-0">
              <span class="material-icons m-0 rounded-circle portal-icon p-1 w-33 h-33">
                more_horiz
              </span>
            </button>
          </div>

        </div>

        <div class="row flex-nowrap" cdkDropListGroup>
          <div [@inbgOutAnimation] *ngIf="showCarouselLeft && !listviewsetting"
            class="position-absolute ps-t-150 ps-l-n12 z-1" (click)="leftShift()">
            <span class="material-icons m-0 p-0 carouselNav cursor-pointer">
              navigate_before
            </span>
          </div>
          <div class="loading_overlay rounded" *ngIf="showSpinner">
            <app-loader></app-loader>
          </div>
          <div class="col" *ngIf="stageList && stageList.length == 0">
            <div class="card bg-secondary">
              <h6 class="p-2 mb-0 align-middle lh-33 font-weight-light">{{ 'projectportal.newprojectmessage' | trans }}
              </h6>
            </div>
          </div>
          <!---- Sticky stage header start 
      <div class="sticky justify-content-between d-flex">
        <div>
          <p class="mb-0 d-inline">Stage title</p>
        </div>
        <div>
          <p class="mb-0 mr-4 d-inline">Start date - 10/10/23</p>
          <p class="mb-0 mr-4 d-inline">End date - 10/10/23</p>
        </div>
      </div>
       Sticky stage header end ---->

          <div class="mb-4 col" [ngClass]="{
              'col-6': stagesInView == 2,
              'col-4': stagesInView == 3,
              'col-3': stagesInView == 4,
              'col-15': stagesInView == 5,
              'col-2': stagesInView == 6
              }" *ngFor="let stage of stageList; let i = index">
            <!--- FIGURE OUT HOW TO DEAL WITH THIS PROBLEM, BUTTON PLACEMENT COVERS CONTENT--->
            <!-- <div *ngIf="canCreateStage()" class="col-auto mobile-reverse-toggle" [@inbgOutAnimation] data-toggle="modal" data-target="#stageeditmodal" (click)="setEditStage(stage)">
                <span class="material-icons m-0 bg-none p-0 position-absolute float-right w-33 h-33 p-1 transistion btn icon rounded-circle cursor-pointer ps-t-30 ps-r-15 bg-transparent-soft opacity-reverse">
                  create
                </span>
              </div> -->
            <app-projectstage [listview]="listviewsetting" [stagecount]="stageList.length"
              [commentsList]="allcommentsList" [stageindex]="i" [projectMembers]="projectMembers"
              [projectCustomerMembers]="projectCustomerMembers" [taskList]="taskList" [stage]="stage"
              [projectCustomerId]="project?.customer" (stageToDelete)="deleteStage($event)"></app-projectstage>
          </div>
          <div [@inbgOutAnimation] *ngIf="showCarouselRight && !listviewsetting"
            class="position-absolute ps-t-150 ps-r-n12" (click)="rightShift()">
            <span class="material-icons m-0 p-0 carouselNav cursor-pointer">
              navigate_next
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<div class="modal" id="stagemodal">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Modal Header  -->
      <div class="modal-header">
        <h4 class="modal-title">{{ 'projectportal.createstage' | trans }}</h4>
        <button #closemodal id="closecreatemodal" type="button" class="close" data-dismiss="modal"
          (click)="resetModal()">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <form #profileForm="ngForm">
          <div *ngIf="errorMessage!=null" class="alert alert-danger ml-0 mr-0">
            <h6 class="error-msg mb-0">{{ errorMessage | trans }}</h6>
          </div>
          <div class="form-group">
            <label class="font-weight-light mb-0 f-13" for="createstagetitle">{{ 'projectportal.stagetitle' | trans
              }}</label>
            <input type="text" class="form-control " id="createstagetitle" aria-describedby="stagetitlehelp"
              placeholder="{{ 'projectportal.stagetitletip' | trans }}" name="title" [(ngModel)]="modalStage.title"
              required />
            <small *ngIf="errorMessage!=null" id="stagetitlehelp" class="form-text text-muted">{{
              'projectportal.stagetitlehelp' | trans }}</small>
          </div>
          <div class="form-group">
            <label class="font-weight-light mb-0 f-13" for="createstagedesc">{{ 'projectportal.stagedescription' | trans
              }}</label>
            <textarea id="stagedesc" ria-describedby="stagedeschelp"
              placeholder="{{ 'projectportal.stagedescriptiontip' | trans }}" name="description"
              [(ngModel)]="modalStage.description" class=" form-control ta-nr" rows="3" required></textarea>
            <small *ngIf="errorMessage!=null" id="stagedeschelp" class="form-text text-muted">{{
              'projectportal.stagedescriptionhelp' | trans }}</small>
          </div>
          <div class="form-group">
            <label class="font-weight-light mb-0 f-13" for="createstartdate">{{ 'projectportal.startdate' | trans
              }}</label>
            <input type="date" class="form-control" id="createstartdate" name="startdate"
              [(ngModel)]="modalStage.startdate" required />
          </div>
          <div class="form-group">
            <label class="font-weight-light mb-0 f-13" for="createenddate">{{ 'projectportal.enddate' | trans }}</label>
            <input type="date" class="form-control" id="createenddate" name="enddate" [(ngModel)]="modalStage.enddate"
              required>
          </div>
          <div class="form-group">
            <label class="font-weight-light mb-0 f-13" for="vendorswitch">{{ 'projectportal.visibility' | trans
              }}</label>
            <select class="form-control" id="vendorswitch" name="stagevisibility"
              [(ngModel)]="modalStage.stagevisibility" required>
              <option [ngValue]="'shared'" value="shared">{{ 'projectstage.shared' | trans }}</option>
              <option value="vendor_only">{{ 'projectstage.vendoronly' | trans }}</option>
            </select>
          </div>
          <div class="row">
            <div class="col">
              <button (click)="resetModal()" id="closemodal" data-dismiss="modal" class="btn-close w-100 mt-1">
                <h6 class="btn-save-text">{{ 'projectportal.close' | trans }}</h6>
              </button>
            </div>
            <div class="col">
              <button id="createstage" (click)="createStage()" type="submit" class="btn-save mt-1">
                <h6 class="btn-save-text">{{ 'projectportal.createstage' | trans }}</h6>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="spacer"></div>
<!-- ASSIGN USER ROLE Modal -->
<div #rolemodal data-toggle="modal" data-target="#customerRoleModal"></div>
<div class="modal fade" id="customerRoleModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'projectportal.roleassignment' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="mb-1">{{ 'projectportal.clarify' | trans }}</p>
        <div class="form-group">
          <input type="text" class="form-control f-13" id="InputRole" placeholder="Role" [(ngModel)]="projectrole">
        </div>
        <div class="row">
          <div class="col">
            <button type="button" class="btn-close float-left" data-dismiss="modal">
              <h6 class="btn-save-text">{{ 'projectportal.close' | trans }}</h6>
            </button>
          </div>
          <div class="col">
            <button type="button" (click)="createMember()" class="btn-save float-right" data-dismiss="modal">
              <h6 class="btn-save-text">{{ 'projectportal.assignrole' | trans }}</h6>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- PROJECT SETTINGS Modal -->
<div class="modal fade" id="settingsModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'projectportal.projectsettings' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-orgprojectedit *ngIf="!customerportal && project" [project]="project" [wizard]="true"></app-orgprojectedit>
        <div class="" style="height:20px;"></div>
        <app-projectsettings></app-projectsettings>
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div> -->
    </div>
  </div>
</div>
<app-taskeditmodal [projectMembers]="projectMembers"
  [projectCustomerMembers]="projectCustomerMembers"></app-taskeditmodal>
<app-alertbox *ngIf="showalerttoggle" [@inbgOutAnimation] [alerticon]="'check_circle'" [alerttype]="'success'"
  [alerttext]="'Stage created'"></app-alertbox>